import React from 'react';
import styled from 'styled-components';
import {
  FRAUD_AWARENESS_BANNER_DESKTOP_IMAGE,
  FRAUD_AWARENESS_BANNER_MOBILE_IMAGE,
  FRAUD_AWARENESS_BANNER_IH_LOGO_IMAGE,
} from '../utils/constants/images';

const LogoMark = styled.img`
  position: absolute;
  right: -40px;
  bottom: -40px;
  width: 220px;
  height: 220px;
  opacity: 0.25;
  pointer-events: none;
`;

const Photo = styled.img`
  width: 337px;
  height: 100%;
  object-fit: cover;
  flex-shrink: 0;
`;

const MobileOnlyPeriod = styled.span`
  display: none;
`;

const TextBlock = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 180px 24px 32px;
  color: white;
`;

const Banner = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  background: #294b5c;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;

  @media (max-width: 960px) {
    flex-direction: column;

    ${LogoMark} {
      display: none;
    }

    ${Photo} {
      width: 100%;
      height: 277px;
    }

    ${TextBlock} {
      padding: 20px;
    }

    ${MobileOnlyPeriod} {
      display: inline;
    }
  }
`;

const Title = styled.h4`
  margin: 0 0 12px 0;
  font-size: 32px;
  font-weight: 500;
`;

const Body = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
`;

const ContactUsLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 700;
  width: auto;
`;

const FraudAwarenessBanner = ({ onContactUsClick }) => (
  <Banner>
    <picture>
      <source media="(max-width: 960px)" srcSet={FRAUD_AWARENESS_BANNER_MOBILE_IMAGE} />
      <Photo src={FRAUD_AWARENESS_BANNER_DESKTOP_IMAGE} alt="" />
    </picture>
    <TextBlock>
      <Title>
        Protect yourself from rental fraud
        <MobileOnlyPeriod>.</MobileOnlyPeriod>
      </Title>
      <Body>
        Invitation Homes employees will never give you login credentials or ask you to share the username and password
        you create. Only make payments through our official payment portal on invitationhomes.com. We will never ask you
        to send money anywhere else. Please{' '}
        <ContactUsLink type="button" onClick={onContactUsClick}>
          contact us
        </ContactUsLink>{' '}
        to report suspicious behavior.
      </Body>
    </TextBlock>
    <LogoMark src={FRAUD_AWARENESS_BANNER_IH_LOGO_IMAGE} alt="" />
  </Banner>
);

export default FraudAwarenessBanner;
